import { createSlice } from '@reduxjs/toolkit';
import { store } from 'app/store';

interface initialStateProps {
    visable: boolean;
    text: string;
    type: string;
    color: string;
}

const initialState = {
    visable: false,
    text: '',
    type: '',
    color: '',
} as initialStateProps;

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        toggleAction(state: any, { payload }: any) {
            state = {
                ...payload,
                visable: true,
            };
            return state;
        },
        dismissAction() {
            return initialState;
        },
    },
});

const { dismissAction: defaultDismissAction, toggleAction: defaultToggleAction } =
    notificationSlice.actions;

export const dismissAction = () => {
    store.dispatch(defaultDismissAction());
};

export const toggleAction = (params: any) => {
    store.dispatch(defaultToggleAction(params));
};

export default notificationSlice.reducer;
